const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success: "¡Usuario creado exitosamente! ¡Ahora iniciá sesión!",
          fail: "Error al crear el usuario. Verificá los datos ingresados.",
        },
        form: {
          name: "Nombre",
          email: "Email",
          password: "Contraseña",
        },
        buttons: {
          submit: "Registrarse",
          login: "¿Ya tenés cuenta? ¡Ingresá!",
        },
      },
      login: {
        title: "Iniciar sesión",
        form: {
          email: "Email",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresar",
          register: "¿No tenés cuenta? ¡Registrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Sesión iniciada exitosamente!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Chats hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En atención"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Resueltos"
          }
        },
        titulo: "Dashboard",
        summaryBanner: "Mostrando datos del {{from}} al {{to}} para {{userName}}",
        filters: {
          title: "Filtros",
          show: "Mostrar filtros",
          hide: "Ocultar filtros"
        }
      },
      connections: {
        outboundPause: {
          chip: "ENVÍOS PAUSADOS",
          switchLabel: "Envíos salientes",
          active: "Activos",
          paused: "PAUSADOS",
          pausedHelp: "Ningún mensaje sale por esta conexión: ni del chat, ni de la IA, ni plantillas, ni recordatorios. Quedan en el chat marcados como no enviados.",
          confirmTitle: "¿Pausar los envíos de {{name}}?",
          confirmMessage: "Mientras esté pausada, NINGÚN mensaje saldrá por esta conexión: respuestas del chat, de la IA, plantillas, confirmaciones y recordatorios de turnos. Los mensajes entrantes se siguen recibiendo. Acordate de reanudarla.",
          confirmButton: "Pausar envíos",
          toastPaused: "Envíos de {{name}} PAUSADOS.",
          toastResumed: "Envíos de {{name}} reanudados.",
        },
        title: "Conexiones",
        empty: "Todavía no hay conexiones.",
        toasts: {
          deleted: "¡Conexión de WhatsApp eliminada exitosamente!",
          restarted: "Conexión reiniciada correctamente",
          newDefault: "{{name}} es ahora tu conexión predeterminada.",
        },
        defaultChanged: {
          message: "Tu conexión predeterminada cambió a {{name}}. Si querés otra, cambiala acá.",
          change: "Cambiar",
          ack: "Entendido",
        },
        metaHealth: {
          checking: "Verificando estado…",
          refresh: "Actualizar estado",
          blockingChip: "Impide enviar",
          blockingNote: "Esto impide que tu número envíe mensajes hasta que lo resuelvas.",
          nonBlockingNote: "No impide el funcionamiento, pero conviene resolverlo.",
          ok: { title: "Conexión activa", desc: "Tu número Meta está listo para enviar y recibir." },
          billing_missing: { title: "Falta configurar el pago", desc: "Tu número NO PUEDE enviar mensajes hasta que configures un método de pago en Meta. Esto es lo que está bloqueando el envío ahora mismo.", descDetected: "Detectamos que Meta rechazó un envío por falta de método de pago. Si ya cargaste una tarjeta, probá enviar de nuevo; si el problema sigue, revisá el Centro de Facturación.", action: "Configurar pago" },
          payment_unverified: { title: "No podemos verificar el método de pago", desc: "Todavía no confirmamos un envío exitoso con este número. Si un envío falla, puede ser porque falta cargar una tarjeta en Meta.", action: "Revisar pago" },
          register_needed: { title: "Falta activar el número", desc: "Tu número está verificado pero todavía no está activado para enviar. Podemos activarlo desde acá.", action: "Reintentar registro", retrying: "Activando…", retryOk: "Número activado. Actualizando estado…", retryFail: "No se pudo activar el número. Probá de nuevo en un momento." },
          pending: { title: "Meta está revisando tu número", desc: "Meta todavía está verificando tu número. Puede tardar un rato; no hay nada que hacer de tu lado por ahora." },
          name_declined: { title: "Nombre rechazado", desc: "Meta rechazó el nombre visible del número. Esto NO bloquea el envío ni la recepción de mensajes; conviene cambiarlo igual para mejorar la entrega: en la pantalla del número, entrá a Perfil → Nombre visible.", action: "Cambiar nombre" },
          quality_low: { title: "Calidad del número baja", desc: "Meta bajó la calidad de tu número. Todavía podés enviar y recibir, pero cuidá el ritmo de envíos para no perder la habilitación." },
          no_templates: { title: "Sin plantillas aprobadas", desc: "No tenés plantillas aprobadas. Podés responder normalmente dentro de las 24 horas, pero necesitás una plantilla para iniciar conversaciones nuevas fuera de esa ventana.", action: "Crear plantilla" },
          check_failed: { title: "No se pudo verificar", desc: "No pudimos consultar el estado en Meta en este momento. Probá actualizar en un rato." },
          qualityChip: "Calidad: {{quality}}",
          quality: { GREEN: "Alta", YELLOW: "Media", RED: "Baja" },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Estás seguro? Deberás leer el código QR nuevamente.",
          disconnectMessageMeta: "¿Estás seguro de desconectar esta conexión Meta?",
          restartTitle: "Reiniciar conexión",
          restartMessage: "¿Reiniciar la conexión? Se preservarán todos los datos y configuraciones. La conexión se reconectará y mostrará un nuevo código QR.",
          restartMessageMeta: "¿Reintentar la conexión? Se preservarán todos los datos y configuraciones. La conexión Meta se volverá a establecer.",
        },
        buttons: {
          add: "Agregar WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Reintentar",
          qrcode: "CÓDIGO QR",
          newQr: "NUEVO CÓDIGO QR",
          connecting: "Conectando",
          restart: "Reiniciar",
          templates: "Plantillas",
          edit: "Editar",
          delete: "Eliminar",
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar la sesión de WhatsApp",
            content:
              "Asegurate de que tu celular esté conectado a internet e intentá nuevamente, o solicitá un nuevo código QR",
          },
          disconnectedMeta: {
            title: "La conexión Meta no está activa",
            content:
              "La conexión con Meta no está activa. Hacé clic en 'Reintentar' para volver a establecerla.",
          },
          qrcode: {
            title: "Esperando lectura del código QR",
            content:
              "Hacé clic en el botón 'CÓDIGO QR' y leé el código QR con tu celular para iniciar la sesión",
          },
          connected: {
            title: "¡Conexión establecida!",
          },
          timeout: {
            title: "Se perdió la conexión con el celular",
            content:
              "Asegurate de que tu celular esté conectado a internet y que WhatsApp esté abierto, o hacé clic en 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          number: "Número",
          type: "Tipo",
          status: "Estado",
          backup: "Respaldo",
          lastUpdate: "Última actualización",
          default: "Predeterminada",
          actions: "Acciones",
          session: "Sesión",
        },
        badges: {
          primary: "PRIMARIA",
          standby: "RESPALDO",
          failover: "EN FAILOVER",
        },
        types: {
          qrPro: "WhatsApp QR — Pro",
          qrWeb: "WhatsApp QR — Web",
          metaCloud: "Meta Cloud API",
          coexistence: "Meta Coexistence",
          qrProDesc: "Estable y eficiente. La opción recomendada para la mayoría.",
          qrWebDesc: "Máxima compatibilidad con todos los dispositivos.",
          metaCloudDesc: "Conexión oficial certificada por Meta. Plantillas y mensajes masivos.",
          coexistenceDesc: "Usá WhatsApp desde tu celular y WAIA al mismo tiempo.",
          notEnabled: "No habilitado",
        },
        alerts: {
          primaryDown: "La conexión {{name}} se desconectó. Verificá la página de conexiones.",
          primaryDownWithStandby: "La conexión {{name}} se desconectó. Usando respaldo {{standby}} automáticamente.",
          standbyDown: "El respaldo {{name}} no está disponible. Solo queda la conexión principal.",
          primaryDownBothFailed: "La conexión {{name}} y su respaldo {{standby}} están desconectados.",
        },
        stepSelectType: "¿Qué tipo de conexión querés agregar?",
        stepConfigure: "Configuración",
        noTypesEnabled: "No hay tipos de conexión habilitados para esta empresa. Contactá al administrador.",
        backupConnection: "Conexión de respaldo",
        noBackup: "Sin respaldo",
        backupOf: "Respaldo de:",
        unlinkBackup: "Desvincular",
        allowedConnectionTypes: "Tipos de conexión habilitados",
      },
      connectionBanner: {
        pausedPrefix: "ENVÍOS PAUSADOS en",
        pausedSuffix: "Ningún mensaje sale por esa conexión.",
        prefix: "La conexión WhatsApp",
        statusDisconnected: "está desconectada",
        statusWaitingQr: "está esperando QR",
        actionQr: "Escaneá el QR para reconectar.",
        actionMeta: "Reintentá la conexión.",
        goToConnections: "Ir a conexiones →",
      },
      whatsappModal: {
        title: {
          add: "Agregar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Predeterminada",
          farewellMessage: "Mensaje de despedida",
          n8nWebhookUrl: "Webhook n8n de esta conexión (opcional)",
          n8nWebhookUrlHelp: "Si se completa, los mensajes que entren por esta línea se envían a este webhook (un bot dedicado por línea). Vacío = usa el webhook de la empresa.",
          backupConnection: "Conexión de respaldo",
          noBackup: "Sin respaldo",
          backupOf: "Esta conexión es respaldo de:",
          unlinkBackup: "Desvincular",
          isPrimary: "Esta conexión es la primaria",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          next: "Siguiente",
        },
        success: "WhatsApp guardado exitosamente.",
        meta: {
          phoneNumberId: "Phone Number ID",
          wabaId: "WABA ID",
          appId: "App ID",
          accessToken: "Access Token",
          whereToFind: "Encontralo en Meta Business → WhatsApp → Configuración de API",
          updateToken: "Actualizar token",
          tokenHidden: "Token guardado ●●●●●●●●",
        },
      },
      qrCode: {
        message: "Leé el código QR para iniciar la sesión",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto eliminado exitosamente!",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro de que querés eliminar este contacto? Se perderán todos los chats relacionados.",
          importMessage: "¿Querés importar todos los contactos del teléfono?",
        },
        buttons: {
          import: "Importar contactos",
          add: "Agregar contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Acciones",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Datos del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de WhatsApp",
          email: "Email",
          extraName: "Nombre del campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado exitosamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada exitosamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de bienvenida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Email",
          password: "Contraseña",
          profile: "Perfil",
          whatsapp: "Conexión predeterminada",
          canSeeUnassigned: "Ver chats sin asignar",
          canViewPhones: "Puede ver números de teléfono", canViewPhonesHelper: "Si está apagado, este usuario ve los números de los contactos enmascarados (ej. +549351●●●●482). Los administradores siempre los ven completos.",
          allowedWhatsapps: "Conexiones permitidas",
          allowedWhatsappsAll: "Todas las conexiones",
          allowedWhatsappsHelp: "Si no seleccionás ninguna, el usuario verá los chats de todas las conexiones.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado exitosamente.",
      },
      chat: {
        noTicketMessage: "Seleccioná un ticket para comenzar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Departamentos",
      },
      tickets: {
        noAccess: "No tenés acceso a este chat.",
        toasts: {
          deleted: "El chat en el que estabas fue eliminado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          deleted: { title: "Eliminados" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar chats y mensajes",
        },
        buttons: {
          showAll: "Todos",
        },
        selectQueueModal: {
          title: "¿Desde qué departamento querés atender?",
          subtitle: "El ticket quedará asignado a este departamento",
          confirm: "Confirmar",
          cancel: "Cancelar",
        },
        selectWhatsappModal: {
          title: "¿Desde qué conexión enviar?",
          subtitle: "Seleccioná la conexión de WhatsApp",
          confirm: "Confirmar",
          cancel: "Cancelar",
        },
        acceptedSuccess: "Ticket tomado correctamente",
      },
      transferTicketModal: {
        title: "Transferir conversación",
        fieldUser: "Asignar a usuario (opcional)",
        fieldUserPlaceholder: "Buscar usuario...",
        fieldQueue: "Departamento",
        fieldQueuePlaceholder: "Seleccionar departamento...",
        fieldConnection: "Conexión",
        fieldNote: "Nota interna (opcional)",
        fieldNotePlaceholder: "Escribí un comentario para el agente que recibe el chat. Usá / para insertar respuestas rápidas.",
        fieldNoteHelper: "Esta nota será visible solo para los agentes en el chat.",
        userNoQueueInfo: "Este usuario no tiene departamento asignado. La conversación se transferirá sin departamento.",
        transferButton: "Transferir",
        cancelButton: "Cancelar",
        disabledTooltip: "Seleccioná un usuario o departamento para continuar",
        successToast: "Conversación transferida",
        noOptions: "No se encontraron usuarios con ese nombre",
        noteHeader: {
          title: "🔄 Transferencia",
          fromTo: "De: {{from}} → {{to}}",
          toQueue: "Departamento {{queue}}",
        },
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "En espera",
        // feat_340: el CHIP del zócalo (no el tab) dice "No leído".
        pendingChipLabel: "No leído",
        assignedHeader: "En atención",
        pendingHeaderShort: "Espera",
        assignedHeaderShort: "Atención",
        noTicketsTitle: "¡Nada aquí!",
        filters: {
          all: "Todos",
          unassigned: "Sin asignar",
          none: "Filtros",
          tags: "Etiquetas",
          filtersLabel: "Filtros:",
          tagPlaceholder: "Etiqueta",
          tagCount: "{{count}} etiquetas",
          tagCountOne: "1 etiqueta",
          contactTypes: "Tipo de Cliente",
          contactTypePlaceholder: "Tipo",
          contactTypeCount: "Tipo: {{count}} seleccionados",
          contactTypeCountOne: "1 tipo seleccionado",
          queuePlaceholder: "Departamento",
          queueCount: "{{count}} departamentos",
          statePlaceholder: "Estado",
          userPlaceholder: "Usuario",
          userCount: "{{count}} usuarios",
          userUnassigned: "Sin asignar",
        },
        noQueue: "Sin departamento",
        noTicketsMessage:
          "No se encontraron chats con ese estado o término de búsqueda",
        connectionTitle: "Conexión que se está usando actualmente.",
        contactsWithoutChat: "Contactos sin chat iniciado",
        startChat: "Iniciar chat",
        group: "Grupo",
        buttons: {
          accept: "Atender",
        },
        deletedView: {
          restoreBtn: "Restaurar",
          restoreOne: "Restaurar este chat",
          hardDeleteBtn: "Eliminar definitivo",
          hardDeleteOne: "Eliminar permanentemente",
        },
      },
      newTicketModal: {
        title: "Crear chat",
        fieldLabel: "Escribí para buscar el contacto",
        add: "Agregar",
        toastExisting: "Ya había un chat con {{name}} — abriendo el existente",
        toastInOtherQueue: "Hay chat en cola \"{{queueName}}\" atendido por {{userName}}. Pedile que te lo transfiera.",
        otherAgent: "otro asesor",
        inOtherQueueActive: "Este chat lo está atendiendo {{userName}} en la cola \"{{queueName}}\". Pedile que te lo transfiera.",
        inOtherQueueClosed: "Este chat pertenece a la cola \"{{queueName}}\" y no tenés acceso.",
        toastNoConnection: "No hay conexiones WhatsApp activas disponibles",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          crmBoard: "Funnel",
          dashboard: "Dashboard",
          announcements: "Comunicados",
          connections: "Conexiones",
          tickets: "Chats",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Departamentos",
          administration: "Administración",
          users: "Equipo",
          settings: "Configuración",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Salir",
            darkMode: "Modo oscuro",
            density: "Densidad",
            densityCompact: "Compacto",
            densityNormal: "Normal",
            densityComfortable: "Amplio",
          },
        },
        sidebar: {
          pin: "Fijar menú",
          unpin: "Desfijar menú",
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Departamentos",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de bienvenida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar departamento",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? Esta acción no se puede revertir. Los tickets de esta cola seguirán existiendo pero sin cola asignada.",
        },
      },
      queueSelect: {
        inputLabel: "Departamentos",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada exitosamente.",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que querés eliminar esta respuesta rápida: ",
          deleteMessage: "Esta acción no se puede revertir.",
        },
      },
      users: {
        title: "Equipo",
        table: {
          name: "Nombre",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexión predeterminada",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar miembro del equipo",
        },
        toasts: {
          deleted: "Usuario eliminado exitosamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Se perderán todos los datos del usuario. Los tickets abiertos serán movidos a la cola.",
        },
      },
      companies: {
        secretariaIaSuperadminLabel: "Secretaria IA",
        secretariaIaSuperadminHelp: "Habilita la Secretaria IA para esta empresa. Si está desactivada, ninguna IA responderá.",
        iaAdminCanToggleLabel: "Permitir control al administrador",
        iaAdminCanToggleHelp: "Si está activo, el admin de esta empresa puede encender o apagar la IA desde su panel.",
      },
      ia: {
        toolbarActiveTooltip: "IA encendida — clic para apagar",
        toolbarInactiveTooltip: "IA apagada — clic para encender",
        toolbarTurnosNote: "Solo la Secretaria/Vendedor IA: el asistente de TurnosIA tiene su propio interruptor (TurnosIA › Ajustes).",
        menuSecretariaLabel: "Secretaria IA",
        menuVendedorLabel: "Vendedor IA",
        vendedorDisabledTooltip: "Activá primero la Secretaria IA",
      },
      settings: {
        success: "Configuración guardada exitosamente.",
        businessInfo: {
          title: "Datos del negocio",
          subtitle: "Información que la IA usa en cada conversación con clientes.",
          address: "Dirección",
          phone: "Teléfono",
          whatsapp: "WhatsApp de atención",
          email: "Email de contacto",
          locationLink: "Link de Google Maps",
          hoursText: "Horarios en texto libre",
          hoursTextHelp: "Ej: Lun a Vie de 9 a 18hs. Texto que la IA le puede leer al cliente.",
          timezone: "Zona horaria",
        },
        businessHours: {
          title: "Horario comercial",
          always247Label: "Disponible 24/7",
          always247Helper: "Si está activo, la empresa se considera siempre disponible independientemente del horario configurado.",
          scheduleLabel: "Horario de atención",
          scheduleHelper: "Define los días y horarios en que la empresa está disponible para recibir consultas. Se usa para el carrito abandonado y otros automatismos.",
        },
        title: "Configuración",
        secretariaIaSuperadminLabel: "Secretaria IA",
        secretariaIaSuperadminHelp: "Habilita la Secretaria IA para esta empresa. Si está desactivada, ninguna IA responderá.",
        vendedorIaSuperadminLabel: "Vendedor IA",
        vendedorIaSuperadminHelp: "Habilita el Vendedor IA. Requiere Secretaria IA activa.",
        iaAdminCanToggleLabel: "Permitir control al administrador",
        iaAdminCanToggleHelp: "Si está activo, el admin de la empresa puede encender o apagar la IA desde su panel.",
        secretariaIaLabel: "Secretaria IA",
        aiSilenceOnTicketOpenLabel: "Silenciar IA al tomar el ticket",
        aiSilenceOnTicketOpenHelp: "Si está activo, cuando un asesor toma (abre) un ticket la IA deja de responder a ese contacto de inmediato, sin esperar a que el asesor escriba. Al cerrar el ticket la IA se reactiva.",
        aiActivateOnlyOnClose: "IA solo al cerrar",
        aiActivateOnlyOnCloseDesc: "Si está activo, la IA no responde durante transferencias entre asesores o departamentos. Solo retoma cuando el ticket se cierra y el contacto escribe de nuevo.",
        secretariaIaHelp: "Controla si la Secretaria IA responde mensajes entrantes.",
        vendedorIaLabel: "Vendedor IA",
        vendedorIaHelp: "Controla si el Vendedor IA toma contactos calificados.",
        vendedorIaDisabledTooltip: "Activá primero la Secretaria IA",
        iaControlSectionTitle: "Inteligencia Artificial",
        iaActiveStatus: "Estado actual",
        iaStatusOn: "Encendida",
        iaStatusOff: "Apagada",
        iaScheduleSectionTitle: "Horario automático de IA",
        iaScheduleEnabledLabel: "Activar IA automáticamente fuera de horario",
        iaScheduleEnabledHelp: "La IA se encenderá sola cuando termine el horario de atención. No se apaga automáticamente al comenzar el horario.",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          n8nWebhookUrl: {
            name: "URL Webhook n8n",
          },
          n8nToken: {
            name: "Token n8n",
          },
          n8nTimeout: {
            name: "Timeout (segundos)",
          },
          n8nRetries: {
            name: "Reintentos",
          },
          n8nPrompt: {
            name: "Prompt IA",
          },
        },
      },
      messagesList: {
        forwarded: "Reenviado",
        // feat_361 — cartel para un mensaje que llegó sin contenido que WAIA sepa
        // dibujar (tipos de Meta no soportados). Antes quedaba la burbuja vacía.
        unsupportedMessage: "Mensaje no compatible",
        historyMediaUnavailable: "📎 Archivo del historial no disponible",
        forwardedMany: "Reenviado muchas veces",
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Atender",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escribí un mensaje o presioná '/' para usar las respuestas rápidas",
        placeholderClosed: "Reabrí o aceptá este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        captionPlaceholder: "Agregar un comentario...",
        cancelMedia: "Cancelar",
        sendMedia: "Enviar",
        dropFileHere: "Soltá el archivo aquí",
      },
      contactDrawer: {
        header: "Datos del contacto",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Información adicional",
      },
      ticketActionButtons: {
        exportTooltip: "Descargar conversación (TXT)",
      },
      ticketOptionsMenu: {
        delete: "Eliminar",
        transfer: "Transferir",
        assignReason: "Asignar motivo",
        scheduleFollowUp: "Programar seguimiento",
        confirmationModal: {
          title: "¿Eliminar conversación con {{name}}?",
          message: "El chat irá a Eliminados. Podés restaurarlo desde allí.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Aceptar",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        confirmationModal: {
          title: "¿Eliminar mensaje?",
          message: "Esta acción no se puede revertir.",
        },
      },
      backendErrors: {
        ERR_TICKET_TRANSFER_NOT_ALLOWED: "No tenés permiso para transferir este ticket.",
        ERR_QUEUE_NOT_FOUND: "No se encontró el departamento.",
        ERR_CRM_DISABLED: "El Funnel no está activado para esta empresa.",
        ERR_SUPPORT_NOT_ALLOWED: "Solo los administradores de la empresa pueden usar Soporte.",
        ERR_SUPPORT_DISABLED: "Soporte no está activado para esta empresa.",
        ERR_SUPPORT_FLAG_SUPERADMIN_ONLY: "Solo el equipo de WAIA puede activar o desactivar Soporte.",
        ERR_SUPPORT_FLAG_INVALID_VALUE: "Valor inválido para activar Soporte.",
        ERR_SUPPORT_TEXT_REQUIRED: "Escribí tu consulta.",
        ERR_SUPPORT_TEXT_TOO_LONG: "La consulta no puede superar los 2000 caracteres.",
        ERR_SUPPORT_INVALID_TICKET: "El ticket indicado no es válido.",
        ERR_SUPPORT_INVALID_CONTACT: "El contacto indicado no es válido.",
        ERR_SUPPORT_INVALID_WHATSAPP: "La conexión indicada no es válida.",
        ERR_SUPPORT_TICKET_NOT_FOUND: "No encontramos ese ticket en tu empresa.",
        ERR_SUPPORT_CONTACT_NOT_FOUND: "No encontramos ese contacto en tu empresa.",
        ERR_SUPPORT_WHATSAPP_NOT_FOUND: "No encontramos esa conexión en tu empresa.",
        ERR_SUPPORT_RATE_LIMIT: "Enviaste muchas consultas en poco tiempo. Probá de nuevo en un rato.",
        ERR_SUPPORT_REQUEST_NOT_FOUND: "No encontramos esa consulta.",
        ERR_SUPPORT_REQUEST_CLOSED: "Esta consulta está cerrada. Si necesitás algo más, abrí una nueva.",
        ERR_SUPPORT_TOO_MANY_ATTACHMENTS: "Podés adjuntar hasta 3 imágenes por consulta.",
        ERR_SUPPORT_ATTACHMENT_TOO_LARGE: "Cada imagen puede pesar hasta 5 MB.",
        ERR_SUPPORT_ATTACHMENT_INVALID_TYPE: "Solo se aceptan imágenes PNG, JPG o WebP.",
        ERR_SUPPORT_ATTACHMENT_NOT_FOUND: "No encontramos esa imagen.",
        ERR_SUPPORT_INVALID_PAYLOAD: "No pudimos leer el formulario. Probá de nuevo.",
        ERR_CRM_NEEDS_ACTIVE_STATES: "El Funnel necesita al menos un estado de contacto activo.",
        ERR_ENTRY_STAGE_MUST_BE_ACTIVE: "Solo una etapa activa puede ser la entrada del Funnel.",
        ERR_LOST_REASON_NOT_FOUND: "El motivo de pérdida elegido no existe.",
        ERR_INVALID_SETTING_VALUE: "Valor de configuración no válido.",
        ERR_INVALID_PARAM: "Parámetro no válido.",
        // feat_210 estándar — motor + modo estándar/a medida + Excel modelo
        ERR_TEMPLATE_VAR_MISMATCH: "La plantilla no tiene la misma cantidad de variables que el perfil de envío.",
        ERR_TEMPLATE_VARS_EXCEED_PROFILE: "La plantilla tiene más variables de las que admite el perfil de envío.",
        ERR_INVALID_HEADER_MATCH: "Configuración del perfil inválida: modo de cabeceras desconocido.",
        ERR_INVALID_TEXT_COLUMNS: "Configuración del perfil inválida: columnas de texto mal definidas.",
        ERR_INVALID_PHONE_PARSER: "Configuración del perfil inválida: lector de teléfonos desconocido.",
        ERR_INVALID_DEFAULT_COUNTRY: "Configuración del perfil inválida: país por defecto no soportado.",
        ERR_INVALID_REQUIRED_FOR_VAR: "Configuración del perfil inválida: requiredForVar debe ser un entero mayor o igual a 1.",
        ERR_INVALID_TEMPLATE_VARS_MODE: "Configuración del perfil inválida: modo de variables desconocido.",
        ERR_INVALID_MAX_VARS: "Cantidad de variables de la plantilla inválida.",
        ERR_NO_FREE_SLOT: "No hay un slot libre en Carga de Datos: los 4 están ocupados.",
        ERR_STANDARD_NOT_ENABLED: "El Excel estándar no está habilitado en esta empresa.",
        ERR_INVALID_STANDARD_MODE: "Modo de carga de datos inválido.",
        ERR_STANDARD_PROFILE_NOT_FOUND: "Esta empresa no tiene habilitado el Excel estándar.",
        ERR_OUTBOUND_PAUSED: "Los envíos de esta conexión están PAUSADOS: el mensaje no se envió. Se reanudan desde Conexiones.",
        ERR_INVALID_PAUSED_VALUE: "Valor inválido para pausar los envíos.",
        // feat_299 — "Ver como usuario"
        ERR_VIEW_AS_INVALID_ID: "El usuario indicado para \"Ver como\" no es válido.",
        ERR_VIEW_AS_REQUIRES_ADMIN: "Solo un administrador puede usar \"Ver como usuario\".",
        ERR_VIEW_AS_USER_NOT_FOUND: "No se encontró ese usuario en tu empresa.",
        ERR_VIEW_AS_INVALID_TARGET: "No podés ver como otro administrador.",
        ERR_PINNED_WHATSAPP_DISCONNECTED: "La conexión asignada a esta conversación está desconectada. Reconectala para poder responder.",
        ERR_OPT_IN_REQUIRED: "Debés confirmar el consentimiento de los destinatarios.",
        ERR_TEMPLATE_HEADER_VARS_NOT_SUPPORTED: "La plantilla tiene variables fuera del cuerpo (encabezado o botón), no soportadas.",
        ERR_TEMPLATE_HEADER_MEDIA_REQUIRED: "Esta plantilla lleva un archivo en el encabezado: adjuntá el archivo para poder enviarla.",
        ERR_TEMPLATE_HEADER_MEDIA_NOT_SUPPORTED: "Esta plantilla no admite adjuntos: su encabezado es de texto.",
        ERR_TEMPLATE_HEADER_MEDIA_TYPE_MISMATCH: "El archivo no coincide con el tipo de encabezado de la plantilla.",
        ERR_TEMPLATE_HEADER_MEDIA_UPLOAD_FAILED: "No se pudo subir el archivo a Meta. Probá de nuevo en unos minutos.",
        ERR_TEMPLATE_HEADER_MEDIA_SAMPLE_MISSING: "Esta plantilla lleva imagen/archivo pero Meta no devolvió el ejemplo aprobado. Sincronizá las plantillas e intentá de nuevo.",
        ERR_TEMPLATE_HEADER_SAMPLE_REQUIRED: "Subí un archivo de muestra: Meta lo pide para aprobar una plantilla con encabezado de archivo.",
        ERR_TEMPLATE_HEADER_SAMPLE_UPLOAD_FAILED: "No se pudo subir el archivo de muestra a Meta. Probá de nuevo en unos minutos.",
        ERR_BULK_IMPORT_IN_PROGRESS: "Ya hay un envío masivo en curso para esta empresa.",
        ERR_WHATSAPP_NOT_CONNECTED: "La conexión seleccionada no está conectada.",
        ERR_NOT_META_CONNECTION: "La conexión seleccionada no es de Meta.",
        ERR_TEMPLATE_NOT_APPROVED: "La plantilla no está aprobada por Meta.",
        ERR_PROFILE_NOT_FOUND: "Perfil de envío no encontrado.",
        ERR_BULK_IMPORT_NOT_FOUND: "Envío masivo no encontrado.",
        ERR_BULK_IMPORT_NOT_CANCELLABLE: "El envío no se puede cancelar en su estado actual.",
        ERR_BULK_IMPORT_NOT_RETRYABLE: "El envío no admite reintento en su estado actual.",
        ERR_META_CONSECUTIVE_FAILURES: "El envío se pausó por fallos consecutivos de Meta.",
        ERR_META_BILLING_MISSING: "No se pudo enviar: falta el método de pago en Meta. Cargá una tarjeta en el Centro de Facturación.",
        ERR_WHATSAPP_NOT_FOUND: "Conexión no encontrada.",
        ERR_TEMPLATE_NOT_FOUND: "Plantilla no encontrada.",
        ERR_FILE_REQUIRED: "Falta el archivo.",

        ERR_NO_OTHER_WHATSAPP: "Debe existir al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verificá la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no está inicializada. Verificá la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verificá la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los archivos de WhatsApp. Verificá la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Por favor intentá nuevamente.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verificá la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya existe un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor ingresá nuevamente.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tenés permiso para acceder a este recurso.",
        ERR_TICKET_LOCKED_BY_OTHER_AGENT: "Este ticket está en atención por otro asesor. No podés escribir.",
        ERR_REQUIRES_SUPER_SUPERADMIN: "Solo el superadmin principal puede realizar esta acción.",
        ERR_COMPANY_OUT_OF_SCOPE: "Esta empresa no pertenece a tu marca.",
        ERR_FEATURE_NOT_ALLOWED: "No tenés permiso para acceder a esta sección.",
        ERR_CANNOT_CHANGE_INSTANCE_ID: "No podés cambiar la marca de una empresa fuera de la tuya.",
        ERR_RESELLER_HAS_NO_WHITELABEL: "Este reseller no tiene una marca asignada.",
        ERR_INVALID_TARGET_COMPANIES: "Solo podés enviar avisos a empresas de tu marca.",
        ERR_TEMPLATE_VARS_MISMATCH: "Faltan ejemplos: cargá un ejemplo por cada variable de la plantilla.",
        ERR_TEMPLATE_VARS_SEQUENCE: "Las variables deben ser correlativas desde {{1}} (sin saltos).",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_USER_EMAIL_EXISTS: "Este email ya está registrado en esta empresa.",
        ERR_PHONE_MASKED: "No se puede usar un número enmascarado.",
        ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró ningún WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al buscar el mensaje en WhatsApp, puede que sea muy antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elegí otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de bienvenida es obligatorio cuando hay más de una cola.",
        ERR_META_INVALID_CREDENTIALS:
          "Credenciales de Meta inválidas. Verificá el Access Token y el Phone Number ID.",
        ERR_META_WINDOW_EXPIRED:
          "Ventana de 24hs expirada. El cliente debe escribir primero.",
        ERR_META_NUMBER_NOT_WA:
          "Este número no tiene una cuenta de WhatsApp activa.",
        ERR_WHATSAPP_ALREADY_LINKED:
          "Esta conexión ya está vinculada a otra. Desvinculá primero.",
        ERR_META_PHONE_ALREADY_LINKED:
          "Este número de Meta ya está conectado en otra empresa. Un mismo número no puede estar en dos empresas.",
      },
      errors: {
        metaWindowExpired: "⚠️ Ventana de 24hs expirada. El cliente debe escribir primero para reanudar la conversación, o usá una plantilla para iniciarla.",
      },
    },
  },
};

export { messages };
